import { BaseQueryFn, EndpointBuilder, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { APP_ENDPOINTS } from 'app/endpoints';
import { NestedProductCategory, ResponseNestedProductCategoryDto } from '../types/dtos';

export default (builder: EndpointBuilder<BaseQueryFn, string, string>) =>
    builder.query<NestedProductCategory, string>({
        async queryFn(nestedProductCategoryId, _queryApi, _extraOptions, fetchWithBQ) {
            const nestedProductCategoryResult = await fetchWithBQ(
                `${APP_ENDPOINTS.NESTED_PRODUCT_CATEGORY}/${nestedProductCategoryId}`,
            );

            if (nestedProductCategoryResult.error)
                return { error: nestedProductCategoryResult.error as FetchBaseQueryError };

            const nestedProductCategory = nestedProductCategoryResult.data as ResponseNestedProductCategoryDto;

            return {
                data: nestedProductCategory,
            };
        },
        providesTags: [{ type: 'nested-product-category', id: 'GET-ID' }],
    });
